import { useEffect, useState } from 'react';
import { useMediaContext } from '../MediaContext';
export const useRoomState = (errorHandler = () => { }) => {
    const { room } = useMediaContext();
    const [state, setState] = useState('disconnected');
    useEffect(() => {
        if (!room)
            return;
        setState(room.state);
        const handleDisconnected = (_, e) => {
            setState(room.state);
            if (e)
                errorHandler(e, room.state);
        };
        const handleReconnected = () => {
            setState(room.state);
        };
        const handleReconnecting = (e) => {
            setState(room.state);
            if (e)
                errorHandler(e, room.state);
        };
        room
            .on('disconnected', handleDisconnected)
            .on('reconnected', handleReconnected)
            .on('reconnecting', handleReconnecting);
        return () => {
            room
                .off('disconnected', handleDisconnected)
                .off('reconnected', handleReconnected)
                .off('reconnecting', handleReconnecting);
        };
    }, [room, errorHandler]);
    return state;
};
//# sourceMappingURL=useRoomState.js.map